import { createFileRoute } from '@tanstack/react-router';
import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';
import SuspenseFallback from '@/components/SuspenseFallback.tsx';
import useStripeCustomerPortalUrl from '@/hooks/useStripeCustomerPortalUrl.ts';
import { z } from 'zod';

const customerPortalSearchParams = z.object({
  returnUrl: z.string().url().optional(),
});

export const Route = createFileRoute('/_manager/customer-portal')({
  component: CustomerPortal,
  validateSearch: (search) => customerPortalSearchParams.parse(search),
});

function CustomerPortal() {
  const { pathname } = useLocation();
  const searchParams = Route.useSearch();

  const returnUrl = useMemo(() => {
    if (
      searchParams.returnUrl === undefined ||
      searchParams.returnUrl.includes(window.location.origin + pathname)
    ) {
      return window.location.origin;
    }
    return searchParams.returnUrl;
  }, [searchParams, pathname]);

  const { data, error } = useStripeCustomerPortalUrl(returnUrl);

  if (error) {
    window.location.replace(returnUrl);
  } else {
    window.location.replace(data.stripeCustomerPortalUrl);
  }
  return <SuspenseFallback />;
}
